import {writable} from 'svelte/store';
import rpcjs from 'rpcjs';

const {persistent} = rpcjs.props;

const BURL = '__MOD_URL__';
// eslint-disable-next-line valid-jsdoc
/**
 */
export function burl(path='') {
    return BURL + path;
};

export const pageWidth = writable(0);
export const pageHeight = writable(0);
export const pageDimension = writable(0);
export const NotFirstVisitLanding = persistent('NotFirstVisitLanding');
export const NotFirstVisitGamer = persistent('NotFirstVisitGamer');
export const FormSubmitted = persistent('FormSubmitted');
export const pageName = persistent(0);
